<template>
  <component
    :is="$sbLinkFix(blok.link) ? NuxtLink : 'div'"
    v-editable="blok"
    :to="$sbLinkFix(blok.link)"
    :target="$sbLinkTarget(blok.link)"
    class="IconBoxBlock upperlink p-32 bg-lighter hover:bg-brandLight transition-all group"
  >
    <nuxt-img
      v-if="blok.icon && blok.icon.filename"
      preset="standard"
      loading="lazy"
      sizes="32px desk:48px"
      class="max-h-32 max-w-32 desk:max-h-40 desk:max-w-40 h-full w-full mb-16 m-auto group-hover:scale-110 transition-transform duration-300"
      :src="blok.icon.filename"
      :alt="blok.icon.alt"
    />
    <p class="type-headline-sm desk:type-headline-base text-center">
      {{ blok.title }}
    </p>
    <div class="type-sm desk:type-base text-center wysiwyg mt-4" v-html="richtext" />
  </component>
</template>

<script lang="ts" setup>
/**
 * This is not a stand alone blok, it's a sub component of "Customer Service Blok"
 */
import { StoryBlokPropBase, StoryBlokAsset, StoryBlokLink } from '~/constants/types/storyblok';
import { ISbRichtext } from 'storyblok-js-client';

const NuxtLink = resolveComponent('NuxtLink');

type Props = StoryBlokPropBase & {
  icon: StoryBlokAsset;
  title: string,
  content: ISbRichtext;
  link: StoryBlokLink,
}

const props = defineProps<{
  blok: Props,
}>();
const richtext = computed(() => renderRichText(props.blok.content));
</script>
